import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function dateFinValiditeValidator(dateType: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateDebutvalidite = moment(control.parent?.get('dateDebutValidite')?.value);
    const dateFinValidite =
      dateType === 'immo'
        ? moment(control.parent?.get('dateFinValiditeImmo')?.value)
        : moment(control.parent?.get('dateFinValidite')?.value);

    if (!dateFinValidite || !dateDebutvalidite) {
      return null;
    }

    const result = dateFinValidite <= dateDebutvalidite ? { finBeforeDebut: true } : null;

    if (dateType === 'fin' || dateType === 'immo') {
      setFinBeforeDebutError(control.parent?.get('dateDebutValidite'), result);
    } else {
      setFinBeforeDebutError(control.parent?.get('dateFinValidite'), result);
      setFinBeforeDebutError(control.parent?.get('dateFinValiditeImmo'), result);
    }

    return result;
  };
}

// Only toggle finBeforeDebut so the sibling's other validation errors are kept
function setFinBeforeDebutError(
  control: AbstractControl | null | undefined,
  result: ValidationErrors | null
) {
  if (!control) return;

  const errors: ValidationErrors = { ...control.errors, ...result };
  if (!result) {
    delete errors['finBeforeDebut'];
  }

  control.setErrors(Object.keys(errors).length ? errors : null);
}
